exports.components = {
  "component---src-lekoarts-gatsby-theme-cara-templates-cara-js": () => import("./../../../src/@lekoarts/gatsby-theme-cara/templates/cara.js" /* webpackChunkName: "component---src-lekoarts-gatsby-theme-cara-templates-cara-js" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */)
}

